// local server
export const devHost = 'http://localhost';
export const devFEPort = 3000;

// production server
// export const devHost = 'https://build.opencui.io';
// export const devFEPort = 443;

export const BaseURL = '/api/v1';
// process.env.NODE_ENV === 'development' ? `${devHost}:${devFEPort}/api/v1` : '/api/v1';

export const GraphQLBaseURL = '/graphql';
  // process.env.NODE_ENV === 'development' ? `${devHost}:${devFEPort}/graphql` : '/graphql';
